import type { ValidPropertyTransformationResult } from './types';

export const VALID_RESULT: ValidPropertyTransformationResult = {
	isValid: true,
};
